(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6851],{

/***/ 16851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CourseCenterRoot; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 35 modules
var esm = __webpack_require__(58880);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./pages/course-center/container/CourseCenterContext.tsx
var CourseCenterContext = __webpack_require__(23523);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./pages/course-center/components/ProductCategoryHeader.tsx




function GameTag(param) {
    var id = param.id, text = param.text;
    var ref = useRef(null);
    var scrollIfNeeded = useCallback(function() {
        var hash = window.location.hash.substring(1);
        var gameCode = hash.split("=")[1];
        if (id === gameCode && ref.current) {
            var y = ref.current.getBoundingClientRect().top + window.pageYOffset - 80;
            window.scrollTo({
                top: y,
                behavior: "smooth"
            });
        }
    }, [
        id
    ]);
    useEffect(function() {
        scrollIfNeeded();
        window.addEventListener("hashchange", function() {
            scrollIfNeeded();
        });
        return function() {
            window.removeEventListener("hashchange", scrollIfNeeded);
        };
    }, [
        id,
        scrollIfNeeded
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        id: id,
        className: classNames("text-xl flex-shrink-0 text-brand"),
        children: text
    });
}
function ProductCategoryHeader(param) {
    var title = param.title;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex overflow-auto hide-scroll justify-between items-center pb-2 border-b border-[#8F8F8F] mb-4",
        children: title
    });
}

// EXTERNAL MODULE: ./components/modal/useModal.ts
var useModal = __webpack_require__(79121);
// EXTERNAL MODULE: ./containers/auth.tsx + 4 modules
var auth = __webpack_require__(88156);
// EXTERNAL MODULE: ./components/Modals/CashierModal.tsx + 5 modules
var CashierModal = __webpack_require__(65397);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(89814);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(97762);
// EXTERNAL MODULE: ./components/swiper-containers/ResponsiveSwiper/styles.module.scss
var styles_module = __webpack_require__(29594);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/swiper-containers/ResponsiveSwiper/ResponsiveSwiper.tsx
// eslint-disable-next-line import/no-unresolved



// eslint-disable-next-line import/no-unresolved







var defaultSlidesPerView = {
    sm: 1,
    md: 2,
    lg: 3
};
function ResponsiveSwiper(param) {
    var children = param.children, _slidesPerView = param.slidesPerView, slidesPerView = _slidesPerView === void 0 ? defaultSlidesPerView : _slidesPerView, _spaceBetween = param.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 28 : _spaceBetween;
    var ref = (0,react.useState)(null), paginateEl = ref[0], setPaginateEl = ref[1];
    var _slidesPerView1 = (0,react.useMemo)(function() {
        return (0,_object_spread/* default */.Z)({}, defaultSlidesPerView, slidesPerView);
    }, [
        slidesPerView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            paginateEl && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                modules: [
                    swiper_esm/* Pagination */.tl
                ],
                className: classnames_default()("w-full", (styles_module_default()).responsiveSwiper),
                slidesPerView: 1,
                breakpoints: {
                    640: {
                        slidesPerView: _slidesPerView1.sm
                    },
                    768: {
                        slidesPerView: _slidesPerView1.md
                    },
                    1024: {
                        slidesPerView: _slidesPerView1.lg
                    }
                },
                spaceBetween: spaceBetween,
                pagination: {
                    el: paginateEl,
                    clickable: true,
                    renderBullet: function(_, className) {
                        return (0,server_browser/* renderToString */.Dq)(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()(className, "border border-gold")
                        }));
                    }
                },
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: function(el) {
                    setPaginateEl(el);
                },
                className: classnames_default()((styles_module_default()).responsiveSwiperNav, "text-center mt-2")
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
// EXTERNAL MODULE: ./node_modules/stripe-ui/dist/Button/index.js
var Button = __webpack_require__(74489);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-hover/use-hover.js
var use_hover = __webpack_require__(79393);
// EXTERNAL MODULE: ./components/ImageComponent/index.tsx
var ImageComponent = __webpack_require__(60429);
// EXTERNAL MODULE: ./utils/currency.ts
var currency = __webpack_require__(95000);
// EXTERNAL MODULE: ./pages/course-center/components/styles.module.scss
var components_styles_module = __webpack_require__(12459);
var components_styles_module_default = /*#__PURE__*/__webpack_require__.n(components_styles_module);
;// CONCATENATED MODULE: ./pages/course-center/components/Card.tsx









function Card(param) {
    var product = param.product, onClick = param.onClick, buttonText = param.buttonText;
    var ref;
    var ref1 = (0,use_hover/* useHover */.X)(), ref2 = ref1.ref, showMask = ref1.hovered;
    var ref3 = (0,useTranslation/* useTranslation */.$)("common"), t = ref3.t, i18n = ref3.i18n;
    var ref4 = (0,useTranslation/* useTranslation */.$)("buynow"), tbuy = ref4.t;
    var productLocale = (0,react.useMemo)(function() {
        return product.localization.code;
    }, [
        product.localization.code
    ]);
    var prefix = (0,react.useMemo)(function() {
        return product.discount_amount ? product.discount_activity_name || t("discount") : tbuy("price");
    }, [
        product.discount_activity_name,
        product.discount_amount,
        t,
        tbuy
    ]);
    var price = (0,react.useMemo)(function() {
        var amount = product.discount_amount || product.amount;
        return new currency/* Currency */.F(amount, productLocale).renderWithSymbol();
    }, [
        product.amount,
        product.discount_amount,
        productLocale
    ]);
    var originalPrice = (0,react.useMemo)(function() {
        return product.discount_amount ? new currency/* Currency */.F(product.amount, productLocale).renderWithSymbol() : null;
    }, [
        product.amount,
        product.discount_amount,
        productLocale
    ]);
    var isProductSoldOut = (0,react.useMemo)(function() {
        return product.availability === "Limited" && product.stock <= 0;
    }, [
        product.availability,
        product.stock
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref2,
        className: classnames_default()("relative rounded w-64 h-[300px] mx-auto cursor-normal shadow-md flex flex-col", (components_styles_module_default()).card),
        children: [
            showMask && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("absolute w-full h-full top-0 left-0 z-1 rounded px-4 py-2 flex flex-col justify-between", (components_styles_module_default()).hoverable),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "overflow-hidden text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white text-lg line-clamp-1",
                                children: product.name
                            }),
                            product.sub_name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-gold line-clamp-1",
                                children: product.sub_name
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-transparent",
                                children: "\xa0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-2 px-4 overflow-auto",
                            children: (ref = product.description) === null || ref === void 0 ? void 0 : ref.split("\n").map(function(l, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "leading-tighter text-xs text-white mb-1",
                                    children: l
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 text-center flex items-end justify-center pb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                disabled: product.in_recurring_subscription || isProductSoldOut,
                                className: "px-10 py-2",
                                variant: "brand",
                                size: "small",
                                onClick: function() {
                                    if (!isProductSoldOut) {
                                        onClick(product);
                                    }
                                },
                                children: isProductSoldOut ? tbuy("sold_out_btn_text") : buttonText
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-full h-36",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageComponent/* default */.Z, {
                        src: product.cover_path || "/images/logo-gga.png",
                        alt: product.name,
                        className: classnames_default()("rounded-t w-full h-full", !product.cover_path && "object-contain bg-codgray-400 p-4")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 left-0 right-0",
                        children: product.availability === "Limited" && product.stock < 10 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-red-500 bg-opacity-40 py-1 text-white text-center",
                            children: product.stock <= 0 ? tbuy("product_sold_out") : tbuy("product_few_left")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 pb-2 pt-2 h-1 flex-1 flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "overflow-hidden flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white text-lg line-clamp-2 mb-1 leading-tight",
                                children: product.name
                            }),
                            product.sub_name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-gold line-clamp-2 leading-tight",
                                children: product.sub_name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-end mt-auto",
                        children: [
                            product.availability === "Limited" && product.stock < 10 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()(product.stock <= 0 ? "text-red-600" : "text-gray-400"),
                                children: [
                                    tbuy("product_stock_count"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: product.stock < 0 ? 0 : product.stock
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-gray-100 text-right flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "line-clamp-1",
                                        children: prefix
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "line-clamp-1",
                                        children: [
                                            originalPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1 text-xs",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "line-through tracking-tight",
                                                    children: originalPrice
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xl text-gold tracking-tight",
                                                children: price
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/course-center/components/ProductCards.tsx







function ProductCards(param) {
    var products = param.products, onSelect = param.onSelect;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveSwiper, {
                    children: products.map(function(p) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                product: p,
                                onClick: function(p) {
                                    onSelect(p);
                                },
                                buttonText: p.type === "Normal" ? t("courses_page.join_free_trial") : t("subscribe", {
                                    ns: "payment-subscription"
                                })
                            }, p.id)
                        }, p.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden md:block mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                    cols: 4,
                    children: products.map(function(p, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                            product: p,
                            onClick: function(p) {
                                onSelect(p);
                            },
                            buttonText: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "uppercase",
                                children: p.type === "Normal" ? t("courses_page.join_free_trial") : t("subscribe", {
                                    ns: "payment-subscription"
                                })
                            })
                        }, p.id);
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./pages/my-class/components/views/LibraryView/FilterSelector.tsx
var FilterSelector = __webpack_require__(98159);
// EXTERNAL MODULE: ./constants/define.ts
var constants_define = __webpack_require__(9775);
;// CONCATENATED MODULE: ./pages/course-center/components/CourseCenterRoot.tsx















function CourseCenterRoot(props) {
    var ref = (0,esm/* useTranslation */.$G)("common"), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,CourseCenterContext/* useCourseCenter */.X)(), groupingProducts = ref1.groupingProducts, selectedGame = ref1.selectedGame, existGames = ref1.existGames, existPrograms = ref1.existPrograms, selectedProgram = ref1.selectedProgram, existedTimeSpan = ref1.existedTimeSpan, selectedTimeSpan = ref1.selectedTimeSpan;
    // console.log(
    //   'gggggggggggggggggg==========groupingProducts',
    //   JSON.stringify(groupingProducts)
    // )
    var ref2 = (0,react.useState)(), product = ref2[0], setProduct = ref2[1];
    var ref3 = (0,useModal/* default */.Z)(), showCashier = ref3.isOpen, toggleCashier = ref3.toggle;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,auth/* useAuth */.aC)(), isAuthenticated = ref4.isAuthenticated, setOpenAuthModal = ref4.setOpenAuthModal;
    var clickProductHandler = (0,react.useCallback)(function(product) {
        if (constants_define/* APP_LOCALE */.Ol === "zh_CN") {
            toggleCashier(true);
            setProduct(product);
        } else {
            if (product.type === "Normal") {
                router.push({
                    pathname: "/cashier",
                    query: {
                        productId: product.id
                    }
                });
            } else {
                router.push({
                    pathname: "/subscription",
                    query: {
                        productId: product.id
                    }
                }, undefined, {
                    shallow: true
                });
            }
        }
    }, [
        router,
        toggleCashier
    ]);
    (0,react.useEffect)(function() {
        if (constants_define/* APP_LOCALE */.Ol === "zh_CN") {
            if (showCashier && !isAuthenticated) {
                setOpenAuthModal(true);
                toggleCashier(false);
            } else if (product !== undefined && isAuthenticated) {
                toggleCashier(true);
            }
        }
    }, [
        isAuthenticated,
        product,
        setOpenAuthModal,
        showCashier,
        toggleCashier
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container max-w-7xl mx-auto pt-8 px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "mb-4 space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSelector/* default */.Z, {
                                size: "small",
                                options: [
                                    {
                                        label: t("all"),
                                        value: null,
                                        origin: null
                                    }, 
                                ].concat((0,_to_consumable_array/* default */.Z)((existPrograms || []).map(function(gc) {
                                    return {
                                        label: gc.name === "Basic" ? "Play" : gc.name || t(gc.name),
                                        value: gc.name,
                                        origin: gc
                                    };
                                }))),
                                category: t("program"),
                                onChange: function(opt) {
                                    if (opt) {
                                        router.push({
                                            pathname: router.pathname,
                                            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                                program: opt
                                            })
                                        }, undefined, {
                                            shallow: true
                                        });
                                    } else {
                                        var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
                                        delete newQuery["program"];
                                        router.push({
                                            pathname: router.pathname,
                                            query: (0,_object_spread/* default */.Z)({}, newQuery)
                                        }, undefined, {
                                            shallow: true
                                        });
                                    }
                                },
                                active: function(o) {
                                    if (o.origin === null) {
                                        return o.origin === selectedProgram;
                                    }
                                    return Boolean(o.origin && o.origin.id === selectedProgram);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSelector/* default */.Z, {
                                size: "small",
                                options: [
                                    {
                                        label: t("all"),
                                        value: null,
                                        origin: null
                                    }, 
                                ].concat((0,_to_consumable_array/* default */.Z)((existGames || []).filter(function(g) {
                                    return !g.hidden;
                                }).map(function(gc) {
                                    return {
                                        label: t(gc.display_code) || gc.name,
                                        value: gc.code,
                                        origin: gc
                                    };
                                }))),
                                category: t("game"),
                                onChange: function(opt) {
                                    if (opt) {
                                        router.push({
                                            pathname: router.pathname,
                                            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                                game: opt
                                            })
                                        }, undefined, {
                                            shallow: true
                                        });
                                    } else {
                                        var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
                                        delete newQuery["game"];
                                        router.push({
                                            pathname: router.pathname,
                                            query: newQuery
                                        }, undefined, {
                                            shallow: true
                                        });
                                    }
                                },
                                active: function(o) {
                                    if (o.origin === null) {
                                        return o.origin === selectedGame;
                                    }
                                    return Boolean(o.origin && o.origin.id === selectedGame);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSelector/* default */.Z, {
                                size: "small",
                                options: [
                                    {
                                        label: t("all"),
                                        value: null,
                                        origin: null
                                    }, 
                                ].concat((0,_to_consumable_array/* default */.Z)((existedTimeSpan || []).map(function(o) {
                                    return {
                                        label: o.label,
                                        value: o.value,
                                        origin: o
                                    };
                                }))),
                                category: t("time_span"),
                                onChange: function(opt) {
                                    if (opt) {
                                        router.push({
                                            pathname: router.pathname,
                                            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                                timeSpan: opt
                                            })
                                        }, undefined, {
                                            shallow: true
                                        });
                                    } else {
                                        var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
                                        delete newQuery["timeSpan"];
                                        router.push({
                                            pathname: router.pathname,
                                            query: newQuery
                                        }, undefined, {
                                            shallow: true
                                        });
                                    }
                                },
                                active: function(o) {
                                    return Boolean(o.value === selectedTimeSpan);
                                }
                            })
                        ]
                    }),
                    Object.keys(groupingProducts).map(function(groupTitle) {
                        var products = groupingProducts[groupTitle];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategoryHeader, {
                                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-gold text-lg",
                                        children: groupTitle ? groupTitle : ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCards, {
                                    onSelect: clickProductHandler,
                                    products: products
                                })
                            ]
                        }, groupTitle);
                    })
                ]
            }),
            product && /*#__PURE__*/ (0,jsx_runtime.jsx)(CashierModal/* CashierModal */.O, {
                product: product,
                isOpen: showCashier,
                onRequestClose: function() {
                    setProduct(undefined);
                    toggleCashier();
                }
            })
        ]
    });
}


/***/ }),

/***/ 23523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ProvideCourseCenterContext; },
/* harmony export */   "X": function() { return /* binding */ useCourseCenter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _context_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99907);
/* harmony import */ var _constants_define__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9775);









var CourseCenterContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var programTypeTranslationMap = {
    Plus: "집중반 PLUS",
    Basic: "취미반 PLAY",
    Trial: "1회 체험"
};
var getUnitTrans = function(timeSpan, unit) {
    if (!timeSpan || !unit) {
        return "";
    }
    if (unit === "Month") {
        if (_constants_define__WEBPACK_IMPORTED_MODULE_5__/* .APP_LOCALE */ .Ol === "kr") {
            return "개월";
        }
    }
    return "".concat(unit).concat((timeSpan || 0) > 1 ? "s" : "");
};
function useCourseCenterContext(isPlatform) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,_context_store__WEBPACK_IMPORTED_MODULE_4__/* .useStore */ .oR)(), gameCategories = ref.gameCategoryState.gameCategories, _productState = ref.productState, allProducts = _productState.products;
    var products = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (allProducts || []).filter(function(p) {
            return isPlatform ? p.product_type === "Platform" : p.product_type !== "Platform";
        });
    }, [
        allProducts,
        isPlatform
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedGame = ref1[0], setSelectedGame = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedProgram = ref2[0], setSelectedProgram = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedTimeSpan = ref3[0], setSelectedTimeSpan = ref3[1];
    var groupingProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        // 根据class的program subtype id group起来，如果是大类是
        var productsWithGroupName = products.map(function(p) {
            var ref, ref1;
            var programTypeName = (ref = p.class) === null || ref === void 0 ? void 0 : ref.program_type.name;
            var programSubTypeName = (ref1 = p.class) === null || ref1 === void 0 ? void 0 : ref1.program_sub_type.name;
            var subTypeNameInKorean = programTypeTranslationMap[programSubTypeName || ""] || programSubTypeName;
            var renderSubTypeName = _constants_define__WEBPACK_IMPORTED_MODULE_5__/* .APP_LOCALE */ .Ol === "kr" ? subTypeNameInKorean : programSubTypeName;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, p), {
                groupTitle: programTypeName === "Play" ? "".concat(renderSubTypeName, " ").concat(p.time_span, " ").concat(getUnitTrans(p.time_span, p.time_span_unit)) : renderSubTypeName
            });
        });
        return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.groupBy)(productsWithGroupName.filter(function(p) {
            return selectedGame ? p.game_category_id === selectedGame : true;
        }).filter(function(p) {
            var ref, ref1;
            return selectedProgram ? ((ref = p.class) === null || ref === void 0 ? void 0 : (ref1 = ref.program_sub_type) === null || ref1 === void 0 ? void 0 : ref1.id) === selectedProgram : true;
        }).filter(function(p) {
            if (selectedTimeSpan) {
                var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(selectedTimeSpan.split(" "), 2), timeSpan = ref[0], unit = ref[1];
                return p.time_span === Number(timeSpan) && p.time_span_unit == unit;
            }
            return true;
        }), "groupTitle");
    }, [
        products,
        selectedGame,
        selectedProgram,
        selectedTimeSpan
    ]);
    var subscriptionProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return products.filter(function(p) {
            return p.type !== "Normal";
        });
    }, [
        products
    ]);
    var gameCategoryIdMap = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.groupBy)(products.filter(function(p) {
            return p.game_category_id;
        }), "game_category_id");
    }, [
        products
    ]);
    var existGames = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (gameCategories || []).filter(function(g) {
            return !!gameCategoryIdMap[g.id];
        });
    }, [
        gameCategories,
        gameCategoryIdMap
    ]);
    var existedTimeSpan = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var timeSpanMap = new Map();
        var timeSpanArr = [];
        products.forEach(function(p) {
            if (p.time_span) {
                timeSpanMap.set("".concat(p.time_span, " ").concat(getUnitTrans(p.time_span, p.time_span_unit)), "".concat(p.time_span, " ").concat(p.time_span_unit));
            }
        });
        timeSpanMap.forEach(function(value, key) {
            timeSpanArr.push({
                label: key,
                value: value
            });
        });
        return timeSpanArr.sort(function(a, b) {
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(a.value.split(" "), 2), aSpan = ref[0], aUnit = ref[1];
            var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(b.value.split(" "), 2), bSpan = ref1[0], bUnit = ref1[1];
            return Number(aSpan) + (aUnit === "Month" ? 1000 : 0) - (Number(bSpan) + (bUnit === "Month" ? 1000 : 0));
        });
    }, [
        products
    ]);
    var existProgramSubTypes = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (products || []).reduce(function(prev, product) {
            var currentSubTypeId = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.get)(product, "class.program_sub_type.id");
            var existed = prev.find(function(p) {
                return p.id === currentSubTypeId;
            });
            if (!existed && !!currentSubTypeId) {
                prev.push(product.class.program_sub_type);
            }
            return prev;
        }, []);
    }, [
        products
    ]);
    var selectedProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (selectedGame === null) {
            return products;
        }
        return products.filter(function(g) {
            return g.game_category_id === selectedGame;
        });
    }, [
        products,
        selectedGame
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (existGames.length && existProgramSubTypes.length) {
            var game = existGames.find(function(g) {
                return g.code === router.query.game;
            });
            var program = existProgramSubTypes.find(function(g) {
                return g.name === router.query.program;
            });
            if (game) {
                setSelectedGame(game.id);
            }
            if (program) {
                setSelectedProgram(program.id);
            }
        }
        if (!router.query.game) {
            setSelectedGame(null);
        }
        if (!router.query.program) {
            setSelectedProgram(null);
        }
        setSelectedTimeSpan(router.query.timeSpan || null);
    }, [
        existGames,
        existProgramSubTypes,
        router.query.game,
        router.query.program,
        router.query.timeSpan,
        selectedGame, 
    ]);
    var productsGroupByGameCategory = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var groupByGameCategoryId = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.groupBy)(products, function(p) {
            return p.game_category_id;
        });
        var items = [];
        Object.keys(groupByGameCategoryId).map(function(id) {
            var list = groupByGameCategoryId[id];
            if (list && list.length) {
                var gc = (gameCategories || []).find(function(cate) {
                    return Number(cate.id) === Number(id);
                });
                if (gc) {
                    items.push({
                        gameCategory: gc,
                        allProducts: list,
                        subscriptionProducts: list.filter(function(p) {
                            return p.type !== "Normal";
                        }),
                        normalProducts: list.filter(function(p) {
                            return p.type === "Normal";
                        })
                    });
                }
            }
        });
        return items.sort(function(i, j) {
            return i.gameCategory.sequence - j.gameCategory.sequence;
        });
    }, [
        gameCategories,
        products
    ]);
    return {
        existGames: existGames,
        existPrograms: existProgramSubTypes,
        selectedGame: selectedGame,
        setSelectedGame: setSelectedGame,
        selectedProgram: selectedProgram,
        setSelectedProgram: setSelectedProgram,
        selectedProducts: selectedProducts,
        subscriptionProducts: subscriptionProducts,
        groupingProducts: groupingProducts,
        productsGroupByGameCategory: productsGroupByGameCategory,
        existedTimeSpan: existedTimeSpan,
        selectedTimeSpan: selectedTimeSpan
    };
}
function ProvideCourseCenterContext(param) {
    var children = param.children, _isPlatform = param.isPlatform, isPlatform = _isPlatform === void 0 ? false : _isPlatform;
    var state = useCourseCenterContext(isPlatform);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CourseCenterContext.Provider, {
        value: state,
        children: children
    });
}
function useCourseCenter() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CourseCenterContext);
}


/***/ }),

/***/ 98159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FilterSelector; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25556);



function FilterSelector(param) {
    var options = param.options, category = param.category, onChange = param.onChange, active = param.active, _size = param.size, size = _size === void 0 ? "normal" : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("overflow-hidden text-white flex hide-scroll", {
            "text-base": size === "normal",
            "text-small": size === "small"
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("hidden md:flex shrink-0 mr-2 w-20"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "py-1.5 cursor-default",
                    children: [
                        category,
                        ":"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "overflow-auto flex md:flex-wrap items-start hide-scroll",
                children: options.map(function(opt) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("cursor-pointer shrink-0 px-2.5 py-1 mr-3 mb-1 rounded hover:text-gray-300 hover:bg-gray-700/30", ((0,_utils_is__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(active) ? active(opt) : active === opt.value) && "!text-gold bg-gold/10"),
                        onClick: function() {
                            onChange(opt.value);
                        },
                        children: opt.label
                    }, opt.label);
                })
            })
        ]
    });
}


/***/ }),

/***/ 29594:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"responsive-swiper":"styles_responsive-swiper__2YFPb","responsiveSwiper":"styles_responsive-swiper__2YFPb","responsive-swiper-nav":"styles_responsive-swiper-nav__01Jrx","responsiveSwiperNav":"styles_responsive-swiper-nav__01Jrx"};

/***/ }),

/***/ 12459:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__HRbp6","hoverable":"styles_hoverable__USrdH"};

/***/ })

}]);